import React, { useEffect, useState } from 'react'
import {motion} from "framer-motion"
import { Link } from 'react-router-dom'
import { projectData } from '../../utils/fakeData/projectData';
import { slideUp } from '../../utils/slideUp';


const ProjectOne = () => {

  const [activeIndex, setActiveIndex] = useState(5);

  useEffect(() => {
    const slideCount = document.querySelectorAll('.main-box li').length - 1;
    const slideWidth = 100 / slideCount + '%';
    document.querySelectorAll('.box').forEach((element) => element.style.width = slideWidth)
  }, []);

  const handleMouseEnter = (index) => {
    setActiveIndex(index);
  };

  return (

    <div className="projects-area pb-75" style={{ padding:'50px 0px'}}>
      <div className="container">

        {/* Title */}
        <div className="projects-section-title">
          <motion.div className="row align-items-center"
              initial="offscreen"
              whileInView="onscreen"
              variants={slideUp()}
              viewport={{ once: true, amount: 0.4 }}
          >
            <div className="col-lg-7 col-md-8">
              <div className="title">
                <span className="d-block glow-button" style={{ fontWeight:'400', width: 'fit-content', padding: '0px 2px' }}>
                  為企業打造的專業 AI 法律服務
                </span>
                <h2>合約生成，無限可能</h2>
              </div>
            </div>
            <div className="col-lg-5 col-md-4">
              <div className="button text-end">
                <Link className="demo text-decoration-none" to="/contract">所有合約類型</Link>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div className="projects-box-info"
          initial="offscreen"
          whileInView="onscreen"
          variants={slideUp()}
          viewport={{ once: true, amount: 0.4 }}
        >
          <ul className="main-box">
            {
              projectData.map(({ id, details, project_name, src }) => {
                return (
                  <li key={id} className={`box bg-${id} ${activeIndex === id ? 'active' : ''}`} onMouseEnter={() => handleMouseEnter(id)}>
                    <span>
                      <img 
                        src={src} 
                        className="projects-image"
                        alt="projects-image" 
                        style={{
                          objectFit: 'cover',
                          objectPosition: '10% 50%'
                        }}
                      />
                    </span>
                    <div className="detail">
                      <div className="content">
                        <h3>
                          <Link className="text-decoration-none" to="/service-details">{project_name}</Link>
                        </h3>
                        <p>{details}</p>
                        <Link className="read-more text-decoration-none" to="/contract">
                          選擇此類型
                          <i className="ri-arrow-right-line"></i>
                        </Link>
                      </div>
                    </div>
                  </li>
                )
              })
            }
          </ul>
        </motion.div>
      </div>
    </div>
  )
}

export default ProjectOne;



